export function getSeriesTotalEpisodes(series: {
  seasons: Array<{ episodes: unknown[] }>;
}): number {
  return series.seasons.reduce((acc, curr) => {
    acc += curr.episodes.length;
    return acc;
  }, 0);
}
